// extracted by mini-css-extract-plugin
export default {"tupacGrid":"kp-z","tupacHeader":"lp-z","tupacHeader2":"mp-z","tupacMenu":"np-z","tupacMenu2":"op-z","tupacMain":"pp-z","tupacMain2":"qp-z"};